import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LatestNews from "./LatestNews";
import ContactSection from "./ContactSection";
import WhatWeDo from "./WhatWeDo";

/* ========================
   TYPES
======================== */

interface Category {
  id: number;
  name: string;
  image: string;
  description: string;
  whatsappMessage: string;
  category_name: string;
}

/* ========================
   COMPONENT
======================== */

const Hardware: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const navigate = useNavigate();
  // const [subcategoryId, setSubcategoryId] = useState<SubCategoryId[]>([]);

  /* ========================
     FETCH CATEGORIES
  ======================== */

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_LYRAZONE_BASE_URL}/categories`,
        );
        setCategories(response.data.categories);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, []);

  /* ========================
     GROUP CATEGORIES
  ======================== */

  const groupedCategories = categories.reduce<Record<string, Category[]>>(
    (acc, category) => {
      if (!acc[category.category_name]) {
        acc[category.category_name] = [];
      }

      acc[category.category_name].push(category);
      return acc;
    },
    {},
  );

  /* ========================
     PRODUCT NAVIGATION
  ======================== */

  const productData = (subCategoryId: number, subCategoryName: string) => {
    navigate(
      `/subproducts?id=${subCategoryId}&name=${encodeURIComponent(
        subCategoryName,
      )}`,
    );
  };

  /* ========================
     RENDER
  ======================== */

  return (
    <>
      {/* ====================================================
                       HOME-P
====================================================== */}

      <div id="home-p" className="home-p pages-head7 text-center">
        <div className="container"></div>
      </div>

      {/* ====================================================
                      BUSINESS-GROWTH-P1
====================================================== */}

      <section id="business-growth-p1" className="business-growth-p1 bg-gray">
        <div className="container">
          <div className="row title-bar">
            <div className="col-md-12">
              <h1 className="wow fadeInUp">SUPER QUALITY HARDWARE</h1>
              <div className="heading-border"></div>
              <p className="wow fadeInUp" data-wow-delay="0.4s">
                We are a leading zone of Information & Communication Technology
                (ICT). We deal and New and Used both type of ICT Hardware.
                Quality is our top most priority that's why we say SUPER QUALITY
                HARDWARE.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ====================================================
                         PRODUCT SECTION
====================================================== */}

      <section id="comp-offer">
        <div className="container-fluid">
          <div className="row">
            {Object.entries(groupedCategories).map(
              ([category, items], catIndex) => (
                <React.Fragment key={catIndex}>
                  <div
                    className="col-md-12 desc-comp-offer wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <h2>{category}</h2>
                    <div className="heading-border-light"></div>
                  </div>

                  {items.map((subCategory, index) => (
                    <div
                      key={index}
                      className="col-md-3 col-sm-6 desc-comp-offer wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <div className="desc-comp-offer-cont">
                        <div className="thumbnail-blogs">
                          <a
                            href={`/subproducts?id=${subCategory.id}&name=${encodeURIComponent(
                              subCategory.name,
                            )}`}
                            onClick={(e) => {
                              e.preventDefault();
                              productData(subCategory.id, subCategory.name);
                            }}
                          >
                            <img
                              src={`${
                                import.meta.env.VITE_LYRAZONE_IMAGE_URL
                              }/uploads/subcategories/${subCategory.image}`}
                              className="img-fluid"
                              alt={subCategory.name}
                            />
                          </a>
                        </div>

                        <h3>{subCategory.name}</h3>
                        <p className="desc">{subCategory.description}</p>

                        <a
                          href={`https://wa.me/+60149936302?text=${subCategory.whatsappMessage}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {/* <button
                            className="btn btn-general btn-silver"
                            role="button"
                          >
                            WhatsApp Now
                          </button> */}
                        </a>
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              ),
            )}
          </div>
        </div>
      </section>

      <WhatWeDo />
      <ContactSection />
      <LatestNews />
    </>
  );
};

/* ========================
   EXTRA COMPONENT
======================== */

// const FinancialContent: React.FC<{
//   title: string;
//   description: string;
// }> = ({ title, description }) => (
//   <div className="financial-p1-cont">
//     <a href="#">
//       <b>Richtech Technology</b>
//     </a>
//     <h3>{title}</h3>
//     <p>{description}</p>
//     <button className="btn btn-general btn-white" role="button">
//       Contact Us
//     </button>
//   </div>
// );

export default Hardware;
